import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import studioService from '@pray/shared/services/studioService';

type UsePurchaseCreditsTopUpProps = {
  artistId: string;
};

type PurchaseCreditsTopUpVariables = {
  quantity: number;
  // A Stripe token for a new card, or the saved card's id.
  paymentToken: string;
};

// The server charges the card and answers; the credits are deposited afterwards by Stripe's charge.succeeded
// webhook, so the account refetched here can still show the old balance. PurchaseSuccessModal waits for it.
export function usePurchaseCreditsTopUp({ artistId }: UsePurchaseCreditsTopUpProps) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ quantity, paymentToken }: PurchaseCreditsTopUpVariables) =>
      studioService.credits.purchaseCreditsTopUp({ artistId, quantity, paymentToken }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.artistCreditAccount(artistId) });
    },
  });
}
